<template>
  <div class="t-lk-modal__content t-lk-change-date">
    <h2 class="t-lk-modal__title">{{ $root.staticText.lk.leadsTime }}</h2>
    <div class="t-lk-modal__text">{{ $root.staticText.lk.leadsTimeText }}</div>

    <div class="t-lk-refuse-lead t-lk-modal__form">
      <div class="t-form__label t-lk-refuse-lead__label">
        {{ textarea.title }}
        <span v-if="textarea.requiredField">*</span>
      </div>
      <textarea
        :class="{ _error: textarea.error, _valid: textarea.valid }"
        class="t-textarea"
        :placeholder="textarea.hintField"
        v-model="textarea.value"
        @focus="focusForm()"
      >
      </textarea>
    </div>

    <div class="t-lk-change-date__row">
      <div class="t-lk-change-date__btn t-btn _green _lk" :class="{ _disabled: disabledBtn }" @click="submit">
        {{ $root.staticText.lk.leadsTimeBtn }}
      </div>
      <div class="t-lk-change-date__close" @click="modalClose">
        {{ $root.staticText.lk.lkModalBtn }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Vue from 'vue'

export default {
  name: 'change-date',
  props: ['props'],
  data() {
    return {
      action: 'lk/leads/changeDate',
      disabledBtn: false,
      textarea: {
        title: this.$root.staticText.forms.comment,
        error: false,
        valid: false,
        hintField: '',
        value: '',
        requiredField: true,
      },
    }
  },
  methods: {
    ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),
    ...mapActions('lk', {
      lk_changeDate: 'leads/changeDate',
    }),

    async submit() {
      let is_valid = true

      if (this.textarea.value.length < 3) {
        this.textarea.error = true
        this.textarea.valid = false
        is_valid = false
      }

      // если длина поля меньше 3 то дальше не делаем
      if (!is_valid) return

      this.disabledBtn = true

      const { data, success } = await this.lk_changeDate({
        id: this.props.leadId,
        date: this.props.date,
        comment: this.textarea.value,
      })

      this.disabledBtn = false
      if (!success) return

      await this.props.changeDateHandler?.()
    },
    focusForm() {
      this.textarea.error = false
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/base/modals/change-date.vue